import SplitPaymentsContainer from "./SplitPaymentsContainer";

export {SplitPaymentsContainer}